import React from "react";
// Using global theme instead of local theme
// import { ThemeProvider, CssBaseline, createTheme, Box, AppBar, Toolbar, Typography, Button, Container } from "@mui/material";
import { Box, AppBar, Toolbar, Typography, Button, Container } from "@mui/material";
import { Outlet, useNavigate } from "react-router-dom";

// const theme = createTheme({
// 	// your theme config (keep same)
// });
const NavigationBar = () => {
	const navigate = useNavigate();

	return (
		<AppBar
			position="sticky"
			elevation={0}
			sx={{
				backgroundColor: "rgba(255, 255, 255, 0.8)",
				backdropFilter: "blur(20px)",
				borderBottom: "1px solid",
				borderColor: "divider",
				color: "text.primary",
			}}>
			<Toolbar
				sx={{
					maxWidth: "1200px",
					width: "100%",
					mx: "auto",
					px: { xs: 2, sm: 3 },
				}}>
				<Typography
					variant="h6"
					sx={{
						flexGrow: 1,
						cursor: "pointer",
						fontWeight: 600,
						fontSize: "1.25rem",
						letterSpacing: "-0.01em",
					}}
					onClick={() => navigate("/explore/sora/")}>
					SORA
				</Typography>

				<Button
					onClick={() => navigate("/explore/sora/")}
					sx={{
						color: "text.primary",
						textTransform: "none",
						fontSize: "0.9375rem",
						fontWeight: 400,
						px: 2,
						"&:hover": { backgroundColor: "transparent", opacity: 0.7 },
					}}>
					Dashboard
				</Button>

				<Button
					onClick={() => navigate("/explore/sora/sales-orders")}
					sx={{
						color: "text.primary",
						textTransform: "none",
						fontSize: "0.9375rem",
						fontWeight: 400,
						px: 2,
						"&:hover": { backgroundColor: "transparent", opacity: 0.7 },
					}}>
					Sales Orders
				</Button>
			</Toolbar>
		</AppBar>
	);
};

const AppContent = () => {
	return (
		<Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
			<NavigationBar />

			<Box
				component="main"
				sx={{
					flexGrow: 1,
					py: { xs: 4, sm: 6, md: 8 },
					backgroundColor: "background.default",
				}}>
				{/* CONTENT WILL COME FROM OUTER ROUTER */}
				<Outlet />
			</Box>

			<Box
				component="footer"
				sx={{
					py: 4,
					px: 2,
					mt: "auto",
					backgroundColor: "background.default",
					borderTop: "1px solid",
					borderColor: "divider",
				}}>
				<Container maxWidth="lg">
					<Typography variant="body2" color="text.secondary" align="center" sx={{ fontSize: "0.8125rem" }}>
						© {new Date().getFullYear()} SORA
					</Typography>
				</Container>
			</Box>
		</Box>
	);
};

const Sora = () => {
	// Using global theme instead of local ThemeProvider
	// return (
	// 	<ThemeProvider theme={theme}>
	// 		<CssBaseline />
	// 		<AppContent /> {/* NO ROUTER HERE */}
	// 	</ThemeProvider>
	// );
	return <AppContent />; // NO ROUTER HERE
};

export default Sora;
